import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DoctorBreadcrumbService } from '../../shared/breadcrumb.service';
import { CountriesService } from '../../../../services/countries.service';
import { Specialty } from '../../../../models/Speciality';
import { SpecialityService } from 'src/app/services/speciality.service';
import { Board, boolean_dregistration, dregistration, Fellowship, Honours, LanguageSpoken, MedicalSchool, Privileges, Publication, Residency, Role, StatesToPractice } from '../../../../models/doctorregistration';
import { DoctorsService } from '../../../../services/doctors.service';
import { SelectItem, ConfirmationService, MessageService } from "primeng/api";
import { fromEvent } from 'rxjs';
import { switchMap, takeUntil, pairwise } from 'rxjs/operators';
import { DaterenderService } from '../../../../services/daterender.service';
import { PromiseResult, ErrorModel, ServerError } from '../../../../models/PromiseResult';
import { HttpErrorResponse } from '@angular/common/http';
import { Title } from '@angular/platform-browser';
import {
    Dimensions,
    ImageCroppedEvent,
    ImageTransform
} from "../../../../image-cropper/interfaces/index";
import { base64ToFile } from "../../../../image-cropper/utils/blob.utils";
import { NgForm } from '@angular/forms';
import { address, blockSpecialCharachters, city, DOCUMENT_SUPPORTED_TYPES, dose_input, GOOGLE_RECAPTCHA_SITE_KEY, IMAGE_PROFILE_ID_SUPPORTED_TYPES, name_input, number_input, phoneNumber, RESUME_SUPPORTED_TYPES, SALUTATIONS, SIGNATURE_TYPES, textareaBox, URLS, zipCode } from "../../../../constant/constant";
import { DoctorRegistrationCheckerService } from 'src/app/services/doctor-registration-checker.service';
import { TraceClassDecorator } from '@sentry/angular';
import {
    Form_Data,
} from '../../../../models/util.models';
import { ProviderStateService } from 'src/app/services/provider-state.service';
import { CertificatesService } from 'src/app/services/certificates.service';


@TraceClassDecorator()
@Component({
    selector: "app-doctorregistration",
    templateUrl: "./doctorregistration.component.html",
    styleUrls: ["./doctorregistration.component.css", "../../../../../assets/css/custom-egd.css"],
    providers: [ConfirmationService],
})
export class DoctorregistrationComponent implements OnInit, AfterViewInit {
    readonly name_input: RegExp = name_input;
    readonly address: RegExp = address;
    readonly city: RegExp = city;
    readonly phoneNumber: RegExp = phoneNumber;
    readonly zipCode: RegExp = zipCode;
    readonly textarea: RegExp = textareaBox;
    readonly dose_input: RegExp = dose_input;
    readonly number_input: RegExp = number_input;
    readonly blockSpecialCharachters: RegExp = blockSpecialCharachters;
    currentYear: number;
    @ViewChild("canvas") public canvas: ElementRef;

    @ViewChild('doctorregistrationform', { static: true }) doctorregistrationform: NgForm;
    // readonly name_regex = /^[A-Za-z\s]+$/
    showForm = true;

    years: SelectItem[] = [];

    year = new Date().getFullYear();


    medicalSchool: MedicalSchool[] = [];

    Fellowship: Fellowship[] = [];

    StatesToPractice: StatesToPractice[] = [];

    Honours: Honours[] = [];

    Privileges: Privileges[] = [];

    Residency: Residency[] = [];

    Board: Board[] = [];
    provider_id: string = "";
    Publication: Publication[] = [];
    // readonly block: RegExp = /^[a-zA-Z^\s]*$/;
    // readonly blockSpecial: RegExp = /^[^<>*!]+$/

    // readonly zipCode: RegExp =  /^[a-zA-Z0-9 ]+$/;

    // firstName = "";
    // middleName = "";
    // lastName = "";
    // dateBirth: Date = null;
    // patient: MembershipModel;
    // userid;
    selectedCountry = null;
    countries: any = [];
    unformattedStates: any[];
    phone: any = []
    selectedState = null;
    StatesToPractice_selectedState = null;
    selectedStateToPratice = null;
    is_uk_country: boolean = false;
    primary_contact_number: string = "";
    secondary_contact_number: string = "";
    selectedPhoneCode_primary: string = "";
    selectedPhoneCode_secondary: string = "";
    temp = [];
    agree: boolean = false;
    patient_guid: any;
    states: any[];
    // statesInput:boolean=true;
    // statesInputDisabled:boolean=true;
    specialities: Specialty[] = [];
    sec_specialities: SelectItem[] = [];
    seletedPrimarySpeciality = null;
    selectedFeatured = null;
    minDate: Date = new Date();
    // consultation: Consultation;
    display: boolean = false;
    slug: string = "";
    doctorreg: dregistration;
    name = "";
    year_of_graduation = null;
    License_no = "";
    national_license_no: string = "";
    honour_name = "";
    privileges_name = "";
    board_certification_name = "";
    publication_name = "";
    national_license: boolean = false;
    roles: Role[];
    selected_role: Role = null;
    selectedSecondarySpeciality: string[] = [];
    is_revalidation_cme_false = true;
    selectedRevalidation_cme = null;
    dateTime = new Date();
    profilePhoto: File = null;
    resume: File = null;
    profile_result: boolean = false;
    resume_result: boolean = false;
    sig_result: boolean = false;
    medicalSchool_edit_id = -1;
    StatesToPractice_edit_id = -1;
    fellowship_edit_id = -1;
    residency_edit_id = -1;
    Honours_edit_id = -1;
    Privileges_edit_id = -1;
    Boards_edit_id = -1;
    Publication_edit_id = -1;
    temp_medicalSchool_name = "";
    temp_medicalSchool_year = null;
    temp_StatesToPractice_selectedStateToPratice: { state_name: string, state_id: number } = { state_name: "", state_id: -1 };
    temp_StatesToPractice_License_no = "";
    // temp_StatesToPractice_state_id=null;
    // temp_StatesToPractice_stateOption=null;
    temp_fellowship_name = "";
    temp_fellowship_year = null;
    temp_residency_name = "";
    temp_residency_year = null;
    temp_Honours_name = "";
    edited_honour_name = "";
    temp_privileges_name = "";
    edited_privileges_name = "";
    temp_boards_name = "";
    edited_boards_name = "";
    temp_publication_name = "";
    edited_publication_name = "";
    confirmDialogVisible1: boolean = false;
    confirmDialogVisible2: boolean = false;
    confirmDialogVisible3: boolean = false;
    confirmDialogVisible4: boolean = false;
    confirmDialogVisible5: boolean = false;
    confirmDialogVisible6: boolean = false;
    confirmDialogVisible7: boolean = false;
    confirmDialogVisible8: boolean = false;
    masterCheckerVisible: boolean = false;

    signatureDialog: boolean = false;

    signatureFile = null;

    imageChangedEvent: any = "";
    croppedImage: any = "";
    canvasRotation = 0;
    rotation = 0;
    scale = 1;
    showCropper = false;
    containWithinAspectRatio = false;
    transform: ImageTransform = {};
    timezone: { label: string, value: number }[] = [];
    selectedTimezone = null;
    current_doctor_userid = "";
    signatureOptionSelected = null;

    languages: LanguageSpoken[] = [];
    selected_language = [];
    signature_file_name = ""

    response: PromiseResult;
    error: ErrorModel;
    serverError: ServerError;
    posting: boolean;

    avatar_url = "";
    label = "";

    masterChecker: boolean = false;
    addedSpeciality: string = "";
    registrationType: string = null;
    signature_file_type_error: boolean = false;

    salutation: SelectItem[] = [];
    selected_salutation: SelectItem = null;
    user_guid: string = null;
    pinMasking: boolean = true;
    noteDialog: boolean = false;
    error_message_result: PromiseResult;
    recaptcha_Reset: boolean = false;
    doctorreg_boolean: boolean_dregistration = this.doctorRegistrationCheckerService.boolean_doctorRegistration_init();
    readonly sitekey: string = GOOGLE_RECAPTCHA_SITE_KEY;
    image_types: string[] = IMAGE_PROFILE_ID_SUPPORTED_TYPES;
    resume_types: string[] = RESUME_SUPPORTED_TYPES;
    document_types: string[] = DOCUMENT_SUPPORTED_TYPES;
    Document_data = [
        {
            id: 0,
            name: 'Enhanced DBS Certificate',
            data: []
        },
        {
            id: 1,
            name: 'GMC Certificate',
            data: []
        },
        {
            id: 2,
            name: 'Professional Indemnity Insurance',
            data: []
        }
    ];
    displayUploadDialog: boolean = false;
    uploadForm: {
        file: File | null;
        expiryDate: any;  // will be a Date object from p-calendar
    } = { file: null, expiryDate: '' };

    currentDocId: number | null = null;
    constructor(private doctorsservice: DoctorsService,
        private router: Router,
        private breadcrumbService: DoctorBreadcrumbService,
        private countryService: CountriesService,
        private specialtyservice: SpecialityService,
        private confirmationService: ConfirmationService,
        private messageService: MessageService,
        private readonly daterenderService: DaterenderService,
        private doctorRegistrationCheckerService: DoctorRegistrationCheckerService,
        private titleService: Title,
        private readonly providerStateService: ProviderStateService,
        private readonly certificateService: CertificatesService,
        private readonly cdr: ChangeDetectorRef
    ) {
        this.currentYear = new Date().getFullYear();
        this.roles = [
            { role_id: 1, name: 'Doctor' },
            { role_id: 2, name: 'Admin' },
            { role_id: 3, name: 'Super Admin' },
            { role_id: 4, name: 'Super Admin Doctor' },
            { role_id: 5, name: 'Admin Doctor' },


        ];
        this.timezone = [
            { label: "IST", value: -330 },
            { label: "PST", value: 480 },
            { label: "EST", value: 600 },
            { label: "GMT", value: 0 },
        ];



    }

    @Input() public width = 300;
    @Input() public height = 70;

    private cx: CanvasRenderingContext2D;

    public ngAfterViewInit() {
        // const canvasEl: HTMLCanvasElement = this.canvas.nativeElement;
        // this.cx = canvasEl.getContext("2d");

        // canvasEl.width = this.width;
        // canvasEl.height = this.height;

        // this.cx.lineWidth = 3;
        // this.cx.lineCap = "round";
        // this.cx.strokeStyle = "#000";

        // this.captureEvents(canvasEl);
        // canvasEl.toBlob((res) => {

        // })
    }

    private async captureEvents(canvasEl: HTMLCanvasElement) {
        // this will capture all mousedown events from the canvas element
        await fromEvent(canvasEl, "mousedown")
            .pipe(
                switchMap((e) => {
                    // after a mouse down, we'll record all mouse moves
                    return fromEvent(canvasEl, "mousemove").pipe(
                        // we'll stop (and unsubscribe) once the user releases the mouse
                        // this will trigger a 'mouseup' event
                        takeUntil(fromEvent(canvasEl, "mouseup")),
                        // we'll also stop (and unsubscribe) once the mouse leaves the canvas (mouseleave event)
                        takeUntil(fromEvent(canvasEl, "mouseleave")),
                        // pairwise lets us get the previous value to draw a line from
                        // the previous point to the current point
                        pairwise()
                    );
                })
            )
            .subscribe(async (res: [MouseEvent, MouseEvent]) => {
                const rect = canvasEl.getBoundingClientRect();

                // previous and current position with the offset
                const prevPos = {
                    x: res[0].clientX - rect.left,
                    y: res[0].clientY - rect.top,
                };

                const currentPos = {
                    x: res[1].clientX - rect.left,
                    y: res[1].clientY - rect.top,
                };

                // this method we'll implement soon to do the actual drawing
                await this.drawOnCanvas(prevPos, currentPos);

            });
    }

    private drawOnCanvas(
        prevPos: { x: number; y: number },
        currentPos: { x: number; y: number }
    ) {
        if (!this.cx) {
            return;
        }

        this.cx.beginPath();

        if (prevPos) {
            this.cx.moveTo(prevPos.x, prevPos.y); // from
            this.cx.lineTo(currentPos.x, currentPos.y);
            this.cx.stroke();
        }
    }



    private async ResetResultModels(): Promise<void> {
        this.response = {
            success: null,
            error: null,
            data: null
        };
        this.serverError = {
            statusCode: null,
            error: null,
            message: null
        };
        this.error_message_result = {
            success: null,
            error: null,
            data: null
        };
    }

    async ngOnInit() {
        this.titleService.setTitle("Dashboard - Doctor Registration");
        this.slug = this.providerStateService.getProviderSlug();
        this.breadcrumbService.setItems([
            { label: 'Dashboard', routerLink: [`/${this.slug}/doctor`] },
            { label: "Doctor Registration" },
            { label: 'Registration' }
        ]);
        this.provider_id = this.providerStateService.getProviderId();
        if (URLS.IS_UK) {
            this.is_uk_country = true;
        }
        this.registrationType = null;
        this.response = {
            success: null,
            error: null,
            data: null
        };
        this.serverError = {
            statusCode: null,
            error: null,
            message: null
        }
        this.showForm = true;
        this.current_doctor_userid = sessionStorage.getItem('userid');


        for (let i = 1900; i <= this.year; i++) {
            this.years.push({ label: (i).toString(), value: (i).toString() });
        }
        this.years.reverse();
        // this.years.push({label:"Select",value:null})

        this.dateTime.setDate(this.dateTime.getDate());
        this.dateTime.setFullYear(this.dateTime.getFullYear() - 18);
        // sessionStorage.setItem('userid','1872468e-9528-42b1-a172-014c3445154c');

        let temp_salutations: SelectItem[] = [];
        for (let i = 0; i < SALUTATIONS.length; i++) {
            temp_salutations.push({ label: SALUTATIONS[i].toString(), value: SALUTATIONS[i].toString() });
        }
        this.salutation = temp_salutations;

        // this.doctorreg = {
        //     has_saved: null,
        //     current_guid: null,
        //     referral_doctor_guid: null,
        //     recaptcha: "",
        //     salutation: null,
        //     token: null,
        //     is_doctor: null,
        //     d_email: "",
        //     password: "",
        //     confirm_password: "",
        //     first_name: "",
        //     middle_name: "",
        //     last_name: "",
        //     gender: "",
        //     date_of_birth: null,
        //     date_of_birth_date: null,
        //     country_id: null,
        //     state_name: null,
        //     city: "",
        //     address_line_1: "",
        //     address_line_2: "",
        //     zip_code: "",
        //     role_id: null,
        //     primary_speciality_id: null,
        //     secondary_speciality: [],
        //     featured_doctor_id: null,
        //     years_experience: null,
        //     license_number: "",
        //     degree: "",
        //     education: null,
        //     timezone: null,
        //     npi_number: "",
        //     revalidation_cme: null,
        //     states_to_practice: [],
        //     board_certification: [],
        //     honors_awards_recognition: [],
        //     publications: [],
        //     hospital_privileges: [],
        //     description: "",
        //     primary_contact_number: "",
        //     secondary_contact_number: "",
        //     pin: "",
        //     language_id: [],
        // }
        this.doctorreg = this.doctorRegistrationCheckerService.doctorRegistration_init(null)
        this.doctorreg_boolean = this.doctorRegistrationCheckerService.boolean_doctorRegistration_init();
        await this.recaptchaReset();
        await this.getCountries();
        await this.getSpecialty();
        await this.getLanguages();

        this.medicalSchool = [];
        this.Fellowship = [];
        this.StatesToPractice = [];
        this.Honours = [];
        this.Residency = [];
        this.Privileges = [];
        this.Board = [];
        this.Publication = [];
        this.noteDialog = true;

    }

    async resetDoctorRegistrationForm() {
        await this.resetDoctorModel()

        this.profilePhoto = null;
        this.resume = null;
        this.signatureFile = null;

        this.addedSpeciality = "";
        this.signatureOptionSelected = null;
        this.agree = false;
        await this.close();


    }
    async onRegistrationTypeChange() {
        this.resetDoctorRegistrationForm();
        // this.doctorregistrationform.reset();
        if (this.registrationType == "Doctor") {
            this.roles = [
                { role_id: 1, name: 'Doctor' },
                // { role_id: 2, name: 'Admin' },
                // { role_id: 3, name: 'Super Admin' },
                { role_id: 4, name: 'Super Admin Doctor' },
                { role_id: 5, name: 'Admin Doctor' },


            ];

            if (JSON.parse(localStorage.getItem("Registration")) == null) {
                this.masterChecker = false;
            }
            else if (JSON.parse(localStorage.getItem("Registration")) != null) {

                await this.NullChecker();
            }


            if (this.masterChecker) {
                // if (event.defaultPrevented) return;
                // event.preventDefault();
                this.confirmationService.confirm({
                    key: 'confirm-local-data',
                    message: 'Are you sure you want to restore previous filled data?',
                    icon: 'pi pi-exclamation-triangle',
                    accept: async () => {
                        await this.getLocalProfileData();
                    },
                });
            }
        }
        else if (this.registrationType == "Admin") {
            this.roles = [
                // { role_id: 1, name: 'Doctor' },
                { role_id: 2, name: 'Admin' },
                { role_id: 3, name: 'Super Admin' },
                // { role_id: 4, name: 'Super Admin Doctor' },
                // { role_id: 5, name: 'Admin Doctor' },


            ];
        }
    }
    RouterNavigation(path: string) {
        this.router.navigate([path]);
    }

    displayMedicalSchool: boolean = false;
    displayFellowship: boolean = false;
    displayStates: boolean = false;
    displayHonours: boolean = false;
    displayResidency: boolean = false;
    displayBcertification: boolean = false;
    displayPublications: boolean = false;
    displayPrivileges: boolean = false;
    editdisplayMedicalSchool: boolean = false;
    editdisplayFellowship: boolean = false;
    editdisplayResidency: boolean = false;
    editdisplayStatesToPractice: boolean = false;

    showAddMedicalSchoolDialog() {
        this.displayMedicalSchool = true;
    }
    showAddFellowshipDialog() {
        this.displayFellowship = true;
    }
    showAddStatesDialog() {
        this.displayStates = true;
    }
    showAddHonoursDialog() {
        this.displayHonours = true;
    }
    showAddResidencyDialog() {
        this.displayResidency = true;
    }
    showAddBcertificationDialog() {
        this.displayBcertification = true;
    }
    showAddPublicationsDialog() {
        this.displayPublications = true;
    }
    showAddPrivilegesDialog() {
        this.displayPrivileges = true;
    }

    close() {
        this.displayMedicalSchool = false;
        this.displayFellowship = false;
        this.displayStates = false;
        this.displayHonours = false;
        this.displayResidency = false;
        this.displayBcertification = false;
        this.displayPublications = false;
        this.displayPrivileges = false;
        this.signatureDialog = false;
        this.resetDialog();

    }

    resetDialog() {
        this.name = "";
        this.year_of_graduation = null;
        this.selectedStateToPratice = null;
        this.License_no = "";
        this.honour_name = "";
        this.privileges_name = "";
        this.year_of_graduation = null;
        this.board_certification_name = "";
        this.publication_name = "";

        this.temp_medicalSchool_name = "";
        this.temp_medicalSchool_year = null;

        this.temp_StatesToPractice_selectedStateToPratice = { state_name: "", state_id: -1 };
        this.temp_StatesToPractice_License_no = "";

        this.temp_fellowship_name = "";
        this.temp_fellowship_year = null;

        this.temp_residency_name = "";
        this.temp_residency_year = null;

        this.edited_honour_name = "";
        this.temp_Honours_name = "";

        this.edited_privileges_name = "";
        this.temp_privileges_name = "";

        this.edited_boards_name = "";
        this.temp_boards_name = "";

        this.edited_publication_name = "";
        this.temp_publication_name = "";

    }

    async getLanguages() {
        await this.doctorsservice.GetLanguageSpoken().toPromise().then(result => {
            if (result.success) {
                let temp_languages: LanguageSpoken[] = [];
                for (let i = 0; i < result.data.length; i++) {
                    let temp: LanguageSpoken = {
                        id: result.data[i].id,
                        language_name: result.data[i].language_name,
                        english_name: result.data[i].english_name,
                        label: result.data[i].english_name + "(" + result.data[i].language_name + ")",
                    }
                    temp_languages.push(temp)
                }
                this.languages = temp_languages;
            }
        });



    }

    async getCountries() {
        await this.countryService.getCountries(this.provider_id).toPromise().then(countries => this.countries = countries);



    }
    async getStates(country_id) {
        await this.countryService.getStates(country_id).toPromise().then(states => this.unformattedStates = states);

    }
    async getSpecialty() {

        await this.specialtyservice.GetAllSpecialities(undefined, this.provider_id).toPromise().then(result => {

            this.specialities = result.data;
        })
        let temp: SelectItem[] = [];
        for (let i = 0; i < this.specialities.length; i++) {
            temp.push({ label: this.specialities[i].specialty_name, value: this.specialities[i].specialty_name });
        }
        this.sec_specialities = temp;

    }
    async onSpecialityChange() {
        if (this.seletedPrimarySpeciality?.id != 0) {
            this.doctorreg.api_data.primary_speciality_id = this.seletedPrimarySpeciality?.id;

            // let temp :AllSpeciality[]= [];
            // this.selectedSecondarySpeciality=[]
            // // let j;
            // for (let i = 0; i < this.specialities.length; i++) {
            //         temp.push(this.pecialities[i].spe);
            // }

            // this.sec_specialities = temp;

        }
    }

    onRevalidationChange(event: Event) {

        this.is_revalidation_cme_false = Boolean(event);
        if (this.is_revalidation_cme_false) {
            this.selectedRevalidation_cme = null;
        }

    }

    onAgreeChange(Event: Event) {

        this.agree = Boolean(Event);
    }

    async changeStates() {
        if (this.selectedCountry != null) {

            this.unformattedStates = [];
            this.states = [];
            this.temp = []
            this.phone = [];
            this.selectedState = null;
            this.selectedStateToPratice = null;
            this.national_license = this.selectedCountry.is_national_license;
            this.national_license_no = "";
            this.StatesToPractice = [];
            // this.getStates(this.selectedCountry.id);
            await this.countryService.getStates(this.selectedCountry.id).toPromise().then(states => this.unformattedStates = states);


            if (this.unformattedStates.length > 0) {
                // this.statesInput=false;

                for (let i = 0; i < this.unformattedStates.length; i++) {
                    this.temp.push({ state_name: this.unformattedStates[i].state_name, state_id: this.unformattedStates[i].id });
                }
                this.states = this.temp;


            }
            else {
                // this.statesInput=true;
                // this.statesInputDisabled=false;
            }

            this.selectedPhoneCode_primary = this.selectedCountry.phone_code;
            this.selectedPhoneCode_secondary = this.selectedCountry.phone_code;


        }
    }

    changePinType() {
        this.pinMasking = !this.pinMasking;
    }

    showDialog() {
        this.posting = false;
        this.display = true;
    }
    addMedicalSchool() {
        this.medicalSchool.push({ si_no: (this.medicalSchool.length + 1).toString(), name: this.name, year: this.year_of_graduation.toString() })
        this.name = "";
        this.year_of_graduation = null;
    }
    deleteMedicalSchool(row) {
        let temp: MedicalSchool[] = [];
        let j;
        for (let i = 0; i < this.medicalSchool.length; i++) {
            if (this.medicalSchool[i].name != row.name && this.medicalSchool[i].year != row.year) {
                temp.push(this.medicalSchool[i]);
            }
            else {
                j = i + 1;
                break;
            }
        }
        for (let i = j; i < this.medicalSchool.length; i++) {
            temp.push({ si_no: (temp.length + 1).toString(), name: this.medicalSchool[i].name, year: this.medicalSchool[i].year })
        }
        this.medicalSchool = temp;
        this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: "Deleted Successfully",
        });
    }

    addFellowship() {
        this.Fellowship.push({ si_no: (this.Fellowship.length + 1).toString(), name: this.name, year: this.year_of_graduation.toString() })
        this.name = "";
        this.year_of_graduation = null;
    }
    deleteFellowship(row) {
        let temp: Fellowship[] = [];
        let j;
        for (let i = 0; i < this.Fellowship.length; i++) {
            if (this.Fellowship[i].name != row.name && this.Fellowship[i].year != row.year) {
                temp.push(this.Fellowship[i]);
            }
            else {
                j = i + 1;
                break;
            }
        }
        for (let i = j; i < this.Fellowship.length; i++) {
            temp.push({ si_no: (temp.length + 1).toString(), name: this.Fellowship[i].name, year: this.Fellowship[i].year })
        }
        this.Fellowship = temp;
        this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: "Deleted Successfully",
        });
    }

    addStatestoPratice() {
        this.StatesToPractice.push({ si_no: (this.StatesToPractice.length + 1).toString(), state_name: this.selectedStateToPratice.state_name, state_id: this.selectedStateToPratice.state_id, license_no: this.License_no, state_data: JSON.stringify({ state_name: this.selectedStateToPratice.state_name, state_id: this.selectedStateToPratice.state_id }) })
        this.selectedStateToPratice = null;
        this.License_no = "";
    }
    deleteStatestoPratice(row) {
        let temp: StatesToPractice[] = [];
        let j;
        for (let i = 0; i < this.StatesToPractice.length; i++) {
            if (this.StatesToPractice[i].state_name != row.state_name && this.StatesToPractice[i].state_id != row.state_id && this.StatesToPractice[i].license_no != row.license_no) {
                temp.push(this.StatesToPractice[i]);
            }
            else {
                j = i + 1;
                break;
            }
        }
        for (let i = j; i < this.StatesToPractice.length; i++) {
            temp.push({ si_no: (temp.length + 1).toString(), state_name: this.StatesToPractice[i].state_name, state_id: this.StatesToPractice[i].state_id, license_no: this.StatesToPractice[i].license_no, state_data: JSON.stringify({ state_name: this.StatesToPractice[i].state_name, state_id: this.StatesToPractice[i].state_id }) });
        }
        this.StatesToPractice = temp;
        this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: "Deleted Successfully",
        });
    }
    addHonours() {
        this.Honours.push({ si_no: (this.Honours.length + 1).toString(), name: this.honour_name })
        this.honour_name = "";
    }
    deleteHonours(row) {
        let temp: Honours[] = [];
        let j;
        for (let i = 0; i < this.Honours.length; i++) {
            if (this.Honours[i].name != row.name) {
                temp.push(this.Honours[i]);
            }
            else {
                j = i + 1;
                break;
            }
        }
        for (let i = j; i < this.Honours.length; i++) {
            temp.push({ si_no: (temp.length + 1).toString(), name: this.Honours[i].name })
        }
        this.Honours = temp;
        this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: "Deleted Successfully",
        });
    }

    addPrivileges() {
        this.Privileges.push({ si_no: (this.Privileges.length + 1).toString(), name: this.privileges_name })
        this.privileges_name = "";
    }
    deletePrivileges(row) {
        let temp: Privileges[] = [];
        let j;
        for (let i = 0; i < this.Privileges.length; i++) {
            if (this.Privileges[i].name != row.name) {
                temp.push(this.Privileges[i]);
            }
            else {
                j = i + 1;
                break;
            }
        }
        for (let i = j; i < this.Privileges.length; i++) {
            temp.push({ si_no: (temp.length + 1).toString(), name: this.Privileges[i].name })
        }
        this.Privileges = temp;
        this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: "Deleted Successfully",
        });

    }

    addResidency() {
        this.Residency.push({ si_no: (this.Residency.length + 1).toString(), name: this.name, year: this.year_of_graduation.toString() })
        this.name = "";
        this.year_of_graduation = null;
    }
    deleteResidency(row) {
        let temp: Residency[] = [];
        let j;
        for (let i = 0; i < this.Residency.length; i++) {
            if (this.Residency[i].name != row.name && this.Residency[i].year != row.year) {
                temp.push(this.Residency[i]);
            }
            else {
                j = i + 1;
                break;
            }
        }
        for (let i = j; i < this.Residency.length; i++) {
            temp.push({ si_no: (temp.length + 1).toString(), name: this.Residency[i].name, year: this.Residency[i].year })
        }
        this.Residency = temp;
        this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: "Deleted Successfully",
        });
    }

    addBoard() {
        this.Board.push({ si_no: (this.Board.length + 1).toString(), name: this.board_certification_name })
        this.board_certification_name = "";
    }
    deleteBoard(row) {
        let temp: Board[] = [];
        let j;
        for (let i = 0; i < this.Board.length; i++) {
            if (this.Board[i].name != row.name) {
                temp.push(this.Board[i]);
            }
            else {
                j = i + 1;
                break;
            }
        }
        for (let i = j; i < this.Board.length; i++) {
            temp.push({ si_no: (temp.length + 1).toString(), name: this.Board[i].name })
        }
        this.Board = temp;
        this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: "Deleted Successfully",
        });
    }

    addPublication() {
        this.Publication.push({ si_no: (this.Publication.length + 1).toString(), name: this.publication_name })
        this.publication_name = "";
    }
    deletePublication(row) {
        let temp: Publication[] = [];
        let j;
        for (let i = 0; i < this.Publication.length; i++) {
            if (this.Publication[i].name != row.name) {
                temp.push(this.Publication[i]);
            }
            else {
                j = i + 1;
                break;
            }
        }
        for (let i = j; i < this.Publication.length; i++) {
            temp.push({ si_no: (temp.length + 1).toString(), name: this.Publication[i].name })
        }
        this.Publication = temp;
        this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: "Deleted Successfully",
        });
    }

    uploadProfileFiles(file: File[]) {

        if (this.image_types.includes(file[0].type.toLowerCase())) {
            if (file[0].size > 5033165) {
                // this.fileu=true;
                this.profilePhoto = null;
            }
            else if (file[0].size < 5033165) {
                // this.fileu=false;
                this.profilePhoto = file[0];
            }
        }
        else {
            this.profilePhoto = null;
        }

    }

    onRemovePhoto() {

        this.profilePhoto = null;
    }

    uploadResumeFiles(file: File[]) {
        if (this.resume_types.includes(file[0].type.toLowerCase())) {
            // this.resume = file[0];
            if (file[0].size > 5033165) {
                // this.fileu=true;
                this.resume = null;
            }
            else if (file[0].size < 5033165) {
                // this.fileu=false;
                this.resume = file[0];
            }
        }
        else {
            this.resume = null;
        }


    }

    onRemoveResume() {

        this.resume = null;
    }

    canceleditData(id, form: string) {
        if (form == "MedicalSchool") {
            this.medicalSchool_edit_id = -1;
            this.medicalSchool[id - 1].name = this.temp_medicalSchool_name;
            this.medicalSchool[id - 1].year = this.temp_medicalSchool_year;
            this.editdisplayMedicalSchool = false;
            this.name = "";
            this.year_of_graduation = null;
            this.temp_medicalSchool_name = "";
            this.temp_medicalSchool_year = null;
        }
        else if (form == "StatesToPractice") {
            this.StatesToPractice_edit_id = -1;
            this.StatesToPractice[id - 1].state_name = this.temp_StatesToPractice_selectedStateToPratice.state_name;
            this.StatesToPractice[id - 1].license_no = this.temp_StatesToPractice_License_no;
            this.StatesToPractice[id - 1].state_id = this.temp_StatesToPractice_selectedStateToPratice.state_id;

            this.editdisplayStatesToPractice = false;
            this.selectedStateToPratice = null;
            this.License_no = "";
            this.temp_StatesToPractice_selectedStateToPratice = { state_name: "", state_id: -1 };
            this.temp_StatesToPractice_License_no = "";

        }
        else if (form == "Fellowship") {
            this.fellowship_edit_id = -1;
            this.Fellowship[id - 1].name = this.temp_fellowship_name;
            this.Fellowship[id - 1].year = this.temp_fellowship_year;
            this.editdisplayFellowship = false;
            this.name = "";
            this.year_of_graduation = null;
            this.temp_fellowship_name = "";
            this.temp_fellowship_year = null;
        }
        else if (form == "Residency") {
            this.residency_edit_id = -1;
            this.Residency[id - 1].name = this.temp_residency_name;
            this.Residency[id - 1].year = this.temp_residency_year;
            this.editdisplayResidency = false;
            this.name = "";
            this.year_of_graduation = null;
            this.temp_residency_name = "";
            this.temp_residency_year = null;
        }
        else if (form == "Honours") {
            this.Honours_edit_id = -1;
            this.Honours[id - 1].name = this.temp_Honours_name;
            this.edited_honour_name = "";
            this.temp_Honours_name = "";
        }
        else if (form == "Privileges") {
            this.Privileges_edit_id = -1;
            this.Privileges[id - 1].name = this.temp_privileges_name;
            this.edited_privileges_name = "";
            this.temp_privileges_name = "";
        }
        else if (form == "Boards") {
            this.Boards_edit_id = -1;
            this.Board[id - 1].name = this.temp_boards_name;
            this.edited_boards_name = "";
            this.temp_boards_name = "";
        }
        else if (form == "Publication") {
            this.Publication_edit_id = -1;
            this.Publication[id - 1].name = this.temp_publication_name;
            this.edited_publication_name = "";
            this.temp_publication_name = "";
        }

    }
    editData(id, form: string) {
        if (form == "MedicalSchool") {
            this.medicalSchool_edit_id = id;
            this.temp_medicalSchool_name = this.medicalSchool[id - 1].name;
            this.temp_medicalSchool_year = this.medicalSchool[id - 1].year;
            this.name = this.temp_medicalSchool_name;
            this.year_of_graduation = this.temp_medicalSchool_year.toString()
            this.editdisplayMedicalSchool = true;
        }
        else if (form == "StatesToPractice") {
            this.StatesToPractice_edit_id = id;
            this.temp_StatesToPractice_selectedStateToPratice.state_name = this.StatesToPractice[id - 1].state_name;
            this.temp_StatesToPractice_selectedStateToPratice.state_id = this.StatesToPractice[id - 1].state_id;
            this.temp_StatesToPractice_License_no = this.StatesToPractice[id - 1].license_no;
            this.selectedStateToPratice = this.temp_StatesToPractice_selectedStateToPratice;
            this.License_no = this.temp_StatesToPractice_License_no;
            this.editdisplayStatesToPractice = true;

        }
        else if (form == "Fellowship") {
            this.fellowship_edit_id = id;
            this.temp_fellowship_name = this.Fellowship[id - 1].name;
            this.temp_fellowship_year = this.Fellowship[id - 1].year;
            this.name = this.temp_fellowship_name;
            this.year_of_graduation = this.temp_fellowship_year.toString()
            this.editdisplayFellowship = true;
        }
        else if (form == "Residency") {
            this.residency_edit_id = id;
            this.temp_residency_name = this.Residency[id - 1].name;
            this.temp_residency_year = this.Residency[id - 1].year;
            this.name = this.temp_residency_name;
            this.year_of_graduation = this.temp_residency_year.toString()
            this.editdisplayResidency = true;
        }
        else if (form == "Honours") {
            this.Honours_edit_id = id;
            this.temp_Honours_name = this.Honours[id - 1].name;
            this.edited_honour_name = this.temp_Honours_name;
        }
        else if (form == "Privileges") {
            this.Privileges_edit_id = id;
            this.temp_privileges_name = this.Privileges[id - 1].name;
            this.edited_privileges_name = this.temp_privileges_name;
        }
        else if (form == "Boards") {
            this.Boards_edit_id = id;
            this.temp_boards_name = this.Board[id - 1].name;
            this.edited_boards_name = this.temp_boards_name;
        }
        else if (form == "Publication") {
            this.Publication_edit_id = id;
            this.temp_publication_name = this.Publication[id - 1].name;
            this.edited_publication_name = this.temp_publication_name;
        }
    }

    saveData(id, form: string) {
        if (form == "MedicalSchool") {
            this.medicalSchool[id - 1].name = this.name;
            this.medicalSchool[id - 1].year = this.year_of_graduation.toString();
            this.medicalSchool_edit_id = -1;
            this.name = "";
            this.year_of_graduation = null;
            this.editdisplayMedicalSchool = false;
            this.temp_medicalSchool_name = "";
            this.temp_medicalSchool_year = null;

        }
        else if (form == "StatesToPractice") {
            this.StatesToPractice[id - 1].state_name = this.selectedStateToPratice.state_name;
            this.StatesToPractice[id - 1].state_id = this.selectedStateToPratice.state_id;
            this.StatesToPractice[id - 1].license_no = this.License_no;
            this.StatesToPractice_edit_id = -1;
            this.selectedStateToPratice = null;
            this.License_no = "";
            this.editdisplayStatesToPractice = false;
            this.temp_StatesToPractice_selectedStateToPratice = { state_name: "", state_id: -1 };
            this.temp_StatesToPractice_License_no = "";

        }
        else if (form == "Fellowship") {
            this.Fellowship[id - 1].name = this.name;
            this.Fellowship[id - 1].year = this.year_of_graduation.toString();
            this.fellowship_edit_id = -1;
            this.name = "";
            this.year_of_graduation = null;
            this.editdisplayFellowship = false;
            this.temp_fellowship_name = "";
            this.temp_fellowship_year = null;
        }
        else if (form == "Residency") {
            this.Residency[id - 1].name = this.name;
            this.Residency[id - 1].year = this.year_of_graduation.toString();
            this.residency_edit_id = -1;
            this.name = "";
            this.year_of_graduation = null;
            this.editdisplayResidency = false;
            this.temp_residency_name = "";
            this.temp_residency_year = null;
        }
        else if (form == "Honours") {
            this.Honours[id - 1].name = this.edited_honour_name;
            this.Honours_edit_id = -1;
            this.edited_honour_name = "";
            this.temp_Honours_name = "";
        }
        else if (form == "Privileges") {
            this.Privileges[id - 1].name = this.edited_privileges_name;
            this.Privileges_edit_id = -1;
            this.edited_privileges_name = "";
            this.temp_privileges_name = "";
        }
        else if (form == "Boards") {
            this.Board[id - 1].name = this.edited_boards_name;
            this.Boards_edit_id = -1;
            this.edited_boards_name = "";
            this.temp_boards_name = "";
        }
        else if (form == "Publication") {
            this.Publication[id - 1].name = this.edited_publication_name;
            this.Publication_edit_id = -1;
            this.edited_publication_name = "";
            this.temp_publication_name = "";
        }
    }

    confirmMedicalSelectDelete(event: Event, product) {
        if (event.defaultPrevented) return;
        event.preventDefault();
        this.confirmationService.confirm({
            key: 'confirm-delete-medicalSchool',
            message: 'Are you sure to delete the ' + product.name + ' ?',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.deleteMedicalSchool(product);
            },
        });

    }

    confirmStatesToPracticeSelectDelete(event: Event, product) {
        if (event.defaultPrevented) return;
        event.preventDefault();
        this.confirmationService.confirm({
            key: 'confirm-delete-StatesToPractice',
            message: 'Are you sure to delete the ' + product.state_name + ' ?',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.deleteStatestoPratice(product);
            },
        });

    }
    confirmFellowshipSelectDelete(event: Event, product) {
        if (event.defaultPrevented) return;
        event.preventDefault();
        this.confirmationService.confirm({
            key: 'confirm-delete-fellowship',
            message: 'Are you sure to delete the ' + product.name + ' ?',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.deleteFellowship(product);
            },
        });

    }

    confirmResidencySelectDelete(event: Event, product) {
        if (event.defaultPrevented) return;
        event.preventDefault();
        this.confirmationService.confirm({
            key: 'confirm-delete-residency',
            message: 'Are you sure to delete the ' + product.name + ' ?',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.deleteResidency(product);
            },
        });

    }

    confirmHonoursSelectDelete(event: Event, product) {
        if (event.defaultPrevented) return;
        event.preventDefault();
        this.confirmationService.confirm({
            key: 'confirm-delete-honours',
            message: 'Are you sure to delete the ' + product.name + ' ?',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.deleteHonours(product);
            },
        });


    }

    confirmPrivilegesSelectDelete(event: Event, product) {
        if (event.defaultPrevented) return;
        event.preventDefault();
        this.confirmationService.confirm({
            key: 'confirm-delete-privileges',
            message: 'Are you sure to delete the ' + product.name + ' ?',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.deletePrivileges(product);
            },
        });

    }

    confirmBoardsSelectDelete(event: Event, product) {
        if (event.defaultPrevented) return;
        event.preventDefault();
        this.confirmationService.confirm({
            key: 'confirm-delete-boards',
            message: 'Are you sure to delete the ' + product.name + ' ?',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.deleteBoard(product);
            },
        });

    }

    confirmPublicationSelectDelete(event: Event, product) {
        if (event.defaultPrevented) return;
        event.preventDefault();
        this.confirmationService.confirm({
            key: 'confirm-delete-publication',
            message: 'Are you sure to delete the ' + product.name + ' ?',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.deletePublication(product);
            },
        });

    }

    fileChangeEvent(event: any): void {
        // debugger;

        this.imageChangedEvent = event;
        if (SIGNATURE_TYPES.includes(event.target.files[0].type.toString())) {
            this.signature_file_type_error = false;
            this.signature_file_name = event.target.files[0].name

        }
        else {
            this.signature_file_type_error = true;
            this.imageChangedEvent = "";
            this.croppedImage = "";
            this.canvasRotation = 0;
            this.rotation = 0;
            this.scale = 1;
            this.showCropper = false;
            this.containWithinAspectRatio = false;
            this.transform = {};
            this.signature_file_name = "";
        }
    }

    imageCropped(event: ImageCroppedEvent) {

        this.croppedImage = event.base64;

        this.signatureFile = base64ToFile(event.base64);
    }

    imageLoaded() {

        this.showCropper = true;

    }

    cropperReady(sourceImageDimensions: Dimensions) {

    }

    loadImageFailed() {

    }

    rotateLeft() {
        this.canvasRotation--;
        this.flipAfterRotate();
    }

    rotateRight() {
        this.canvasRotation++;
        this.flipAfterRotate();
    }

    private flipAfterRotate() {
        const flippedH = this.transform.flipH;
        const flippedV = this.transform.flipV;
        this.transform = {
            ...this.transform,
            flipH: flippedV,
            flipV: flippedH
        };
    }

    flipHorizontal() {
        this.transform = {
            ...this.transform,
            flipH: !this.transform.flipH
        };
    }

    flipVertical() {
        this.transform = {
            ...this.transform,
            flipV: !this.transform.flipV
        };
    }

    resetImage() {
        this.scale = 1;
        this.rotation = 0;
        this.canvasRotation = 0;
        this.transform = {};
    }

    zoomOut() {
        this.scale -= 0.1;
        this.transform = {
            ...this.transform,
            scale: this.scale
        };
    }

    zoomIn() {
        this.scale += 0.1;
        this.transform = {
            ...this.transform,
            scale: this.scale
        };
    }

    toggleContainWithinAspectRatio() {
        this.containWithinAspectRatio = !this.containWithinAspectRatio;
    }

    updateRotation() {
        this.transform = {
            ...this.transform,
            rotate: this.rotation
        };
    }

    addSignature() {
        this.showCropper = false;
        this.signature_file_type_error = false;
        this.signatureDialog = true;


    }

    saveSignature() {
        this.signatureDialog = false;

    }

    async addNewSpeciality() {
        const temp: SelectItem[] = this.sec_specialities;


        let tempaddedSpeciality = this.addedSpeciality.trim().toLowerCase().split(" ");
        for (let i = 0; i < tempaddedSpeciality.length; i++) {
            tempaddedSpeciality[i] = tempaddedSpeciality[i][0].toUpperCase() + tempaddedSpeciality[i].slice(1);
        }
        let b = tempaddedSpeciality.join(" ");
        //  code for /

        let tempSpaecialitiesName: string[] = [];
        for (let i = 0; i < temp.length; i++) {
            tempSpaecialitiesName.push(temp[i].label);
        }
        tempSpaecialitiesName.push(b);
        this.selectedSecondarySpeciality.push(b.toString());


        let tempSpaecialities = Array.from(new Set(tempSpaecialitiesName)).sort()
        let temp1: SelectItem[] = [];
        for (let i = 0; i < tempSpaecialities.length; i++) {
            temp1.push({ label: tempSpaecialities[i].toString(), value: tempSpaecialities[i].toString() });
        }
        this.sec_specialities = temp1;
        this.addedSpeciality = "";

    }
    async submitData(): Promise<void> {
        await this.recaptchaReset();
        if (this.registrationType == 'Doctor') {
            await this.ResetResultModels();
            this.posting = true;

            this.doctorreg.api_data.is_doctor = true;

            this.doctorreg.api_data.timezone = 0;
            if (this.doctorreg.api_data.date_of_birth_date == null) {
                this.doctorreg.api_data.date_of_birth = null;
            }
            else if (this.doctorreg.api_data.date_of_birth_date != null) {
                this.doctorreg.api_data.date_of_birth = this.daterenderService.render_data(this.doctorreg.api_data.date_of_birth_date);
            }

            if (this.doctorreg.api_data.middle_name == "") {
                this.doctorreg.api_data.middle_name = "";
            }
            else {
                this.doctorreg.api_data.middle_name = this.doctorreg.api_data.middle_name;
            }

            if (this.doctorreg.api_data.address_line_2 == "") {
                this.doctorreg.api_data.address_line_2 = "";
            }
            else {
                this.doctorreg.api_data.address_line_2 = this.doctorreg.api_data.address_line_2;
            }


            if (this.selectedCountry == null) {
                this.doctorreg.api_data.country_id = null;
            }
            else if (this.selectedCountry != null) {
                this.doctorreg.api_data.country_id = this.selectedCountry?.id;
            }

            if (this.selected_salutation == null) {
                this.doctorreg.api_data.salutation = null;
            }
            else if (this.selected_salutation != null) {
                this.doctorreg.api_data.salutation = this.selected_salutation.value;
            }

            if (this.selectedState == null) {
                this.doctorreg.api_data.state_name = null;
            }
            else if (this.selectedState != null) {
                this.doctorreg.api_data.state_name = this.selectedState.state_name;
            }

            if (this.seletedPrimarySpeciality == null) {
                this.doctorreg.api_data.primary_speciality_id = null;
            }
            else if (this.seletedPrimarySpeciality != null) {
                this.doctorreg.api_data.primary_speciality_id = this.seletedPrimarySpeciality.id;
            }

            if (this.doctorreg.api_data.years_experience == null) {
                this.doctorreg.api_data.years_experience = null;
            }
            else if (this.doctorreg.api_data.years_experience != null) {
                this.doctorreg.api_data.years_experience = Number(this.doctorreg.api_data.years_experience);
            }



            if (this.selected_role == null) {
                this.doctorreg.api_data.role_id = null;
            }
            else if (this.selected_role != null) {
                this.doctorreg.api_data.role_id = this.selected_role?.role_id;
            }

            this.doctorreg.api_data.education = { medical_school: this.medicalSchool, residency: this.Residency, fellowship: this.Fellowship };

            if (!this.national_license) {
                let tempStatesToPractice: StatesToPractice[] = [];
                // for(let i=0;i<this.StatesToPractice.length;i++)
                // {
                //  this.doctorreg.states_to_practice.push(this.StatesToPractice[i].name);
                tempStatesToPractice = this.StatesToPractice;
                // }
                this.doctorreg.api_data.states_to_practice = tempStatesToPractice;
            }
            else if (this.national_license) {
                let tempStatesToPractice: StatesToPractice[] = [];
                if (this.national_license_no.length > 0)
                    tempStatesToPractice.push({ si_no: (1).toString(), state_name: "ALL", state_id: 0, license_no: this.national_license_no, state_data: JSON.stringify({ state_name: "ALL", state_id: 0, }) });
                this.doctorreg.api_data.states_to_practice = tempStatesToPractice;
            }

            let tempBoard: string[] = [];
            for (let i = 0; i < this.Board.length; i++) {
                //  this.doctorreg.board_certification.push(this.Board[i].name)
                tempBoard.push(this.Board[i].name)
            }
            this.doctorreg.api_data.board_certification = tempBoard;

            let tempHonours: string[] = [];
            for (let i = 0; i < this.Honours.length; i++) {
                //  this.doctorreg.honors_award.spush(this.Honours[i].name)
                tempHonours.push(this.Honours[i].name)
            }
            this.doctorreg.api_data.honors_awards_recognition = tempHonours;

            let tempPublication: string[] = [];
            for (let i = 0; i < this.Publication.length; i++) {
                //  this.doctorreg.publications.push(this.Publication[i].name)
                tempPublication.push(this.Publication[i].name)
            }
            this.doctorreg.api_data.publications = tempPublication

            let tempPrivileges: string[] = [];
            for (let i = 0; i < this.Privileges.length; i++) {
                //  this.doctorreg.hospital_privileges.push(this.Privileges[i].name)
                tempPrivileges.push(this.Privileges[i].name)
            }
            this.doctorreg.api_data.hospital_privileges = tempPrivileges

            if (this.primary_contact_number?.length > 0) {
                this.doctorreg.api_data.primary_contact_number = '+' + this.selectedPhoneCode_primary + this.primary_contact_number.slice(-10);
            }
            if (this.secondary_contact_number?.length > 0) {
                this.doctorreg.api_data.secondary_contact_number = '+' + this.selectedPhoneCode_secondary + this.secondary_contact_number.slice(-10);
            }

            this.doctorreg.api_data.license_number = this.national_license_no;

            let tempselectedSecondarySpeciality: string[] = [];
            if (this.selectedSecondarySpeciality.length > 0) {
                for (let i = 0; i < this.selectedSecondarySpeciality.length; i++) {
                    //  this.doctorreg.secondary_speciality.push(this.selectedSecondarySpeciality[i].specialty_name)
                    tempselectedSecondarySpeciality.push(this.selectedSecondarySpeciality[i].toString())
                }
            }

            this.doctorreg.api_data.secondary_speciality = tempselectedSecondarySpeciality;

            let tempselectedLanguageSpoken: string[] = [];
            for (let i = 0; i < this.selected_language.length; i++) {
                tempselectedLanguageSpoken.push(this.selected_language[i].id);
            }

            this.doctorreg.api_data.language_id = tempselectedLanguageSpoken;

            if (this.selectedFeatured == "Yes")
                this.doctorreg.api_data.featured_doctor_id = true;
            else if (this.selectedFeatured == "No")
                this.doctorreg.api_data.featured_doctor_id = false;

            // try {
            if (this.is_revalidation_cme_false) {
                if (this.selectedRevalidation_cme != null) {
                    this.doctorreg.api_data.revalidation_cme = Number(this.selectedRevalidation_cme.value);
                }
                else {
                    this.doctorreg.api_data.revalidation_cme == null
                }
            }
            else if (this.is_revalidation_cme_false)
                this.doctorreg.api_data.revalidation_cme = null;
            this.doctorreg_boolean = await this.doctorRegistrationCheckerService.DoctorRegistrationFormSubmitChecker(this.doctorreg.api_data, true, this.profilePhoto, this.signatureOptionSelected, this.signatureFile, this.agree);
            this.error_message_result = await this.doctorRegistrationCheckerService.getDoctorRegFormErrors(this.doctorreg_boolean, this.national_license)
            if (!Boolean(this.error_message_result.success)) {
                this.posting = false;
            }
            if (Boolean(this.error_message_result.success)) {
                await this.uploadDataDoctor();
            }

        }


        else if (this.registrationType == 'Admin') {
            await this.ResetResultModels();
            this.posting = true;

            this.doctorreg.api_data.is_doctor = false;
            this.doctorreg.api_data.timezone = 0;

            if (this.doctorreg.api_data.date_of_birth_date == null) {
                this.doctorreg.api_data.date_of_birth = null;
            }
            else if (this.doctorreg.api_data.date_of_birth_date != null) {
                this.doctorreg.api_data.date_of_birth = this.daterenderService.render_data(this.doctorreg.api_data.date_of_birth_date);
            }

            if (this.selectedCountry == null) {
                this.doctorreg.api_data.country_id = null;
            }
            else if (this.selectedCountry != null) {
                this.doctorreg.api_data.country_id = this.selectedCountry.id;
            }

            if (this.selectedState == null) {
                this.doctorreg.api_data.state_name = null;
            }
            else if (this.selectedState != null) {
                this.doctorreg.api_data.state_name = this.selectedState.state_name;
            }

            if (this.primary_contact_number?.length > 0) {
                this.doctorreg.api_data.primary_contact_number = '+' + this.selectedPhoneCode_primary + this.primary_contact_number.slice(-10);
            }
            if (this.secondary_contact_number?.length > 0) {
                this.doctorreg.api_data.secondary_contact_number = '+' + this.selectedPhoneCode_secondary + this.secondary_contact_number.slice(-10);
            }

            if (this.selected_role == null) {
                this.doctorreg.api_data.role_id = null;
            }
            else if (this.selected_role != null) {
                this.doctorreg.api_data.role_id = this.selected_role?.role_id;
            }




            let tempselectedLanguageSpoken: string[] = [];
            for (let i = 0; i < this.selected_language.length; i++) {
                tempselectedLanguageSpoken.push(this.selected_language[i].id);
            }

            this.doctorreg.api_data.language_id = tempselectedLanguageSpoken;
            this.doctorreg.api_data.featured_doctor_id = false;

            this.doctorreg.api_data.license_number = null;
            this.doctorreg.api_data.revalidation_cme = null;
            this.doctorreg.api_data.primary_speciality_id = null;
            this.doctorreg.api_data.secondary_speciality = null;
            this.doctorreg.api_data.years_experience = null;
            this.doctorreg.api_data.license_number = null;
            this.doctorreg.api_data.education = null;
            this.doctorreg.api_data.degree = null;
            this.doctorreg.api_data.npi_number = null;
            this.doctorreg.api_data.revalidation_cme = null;
            this.doctorreg.api_data.states_to_practice = null;
            this.doctorreg.api_data.board_certification = null;
            this.doctorreg.api_data.honors_awards_recognition = null;
            this.doctorreg.api_data.publications = null;
            this.doctorreg.api_data.hospital_privileges = null;
            this.doctorreg.api_data.description = null;
            this.doctorreg.api_data.pin = null;

            // let boolean_doctorreg:boolean_dregistration=await  this.doctorRegistrationCheckerService.FormSubmitChecker(this.doctorreg,true,this.profilePhoto,this.signatureOptionSelected,this.signatureFile,this.agree);
            // this.error_message_result=await this.doctorRegistrationCheckerService.getDoctorRegFormErrors(boolean_doctorreg,this.national_license)
            // if(!Boolean(this.error_message_result.success)){
            // this.posting=false;
            // }
            // if(Boolean(this.error_message_result.success)){
            await this.UploadDataAdmin();
            // }

        }
    }

    async uploadDataDoctor() {



        this.doctorreg.form_data = new Form_Data();
        this.doctorreg.form_data.form_data = this.doctorreg.form_data.create_form_data(this.doctorreg.api_data, new FormData(), "");


        // for (const [key, value] of Object.entries(this.doctorreg.api_data)) {
        //     console.log(key);
        //     console.log("val:", value)
        //     if (value != null && value !== undefined) {
        //         const serializedValue = typeof value === 'object' ? JSON.stringify(value) : value.toString();
        //         //console.log(key);
        //         //console.log("val:", value)
        //         formData.append(key, serializedValue);
        //     }
        // }

        if (this.profilePhoto) {
            this.doctorreg.form_data.form_data.append('avatar', this.profilePhoto);
        }

        if (this.resume) {
            this.doctorreg.form_data.form_data.append('resume', this.resume);
        }

        await this.doctorsservice.createDoctor(this.doctorreg.form_data.form_data).toPromise().then(async result => {

            this.response = result;
            if (this.response.success) {
                this.user_guid = result.data.user_guid;
                this.uploadCertificates();
                this.showForm = false;
                this.display = true;
                await this.showDialog();
                //this.user_guid = result.data.user_guid;
                // let formPhoto: FormData = new FormData();
                // formPhoto.set("file", this.profilePhoto);

                // await this.doctorsservice.UploadDoctorProfilePhoto(formPhoto, this.user_guid).toPromise().then(result => {

                //     this.response = result;
                //     if (this.response.success) {
                //         this.profile_result = result.success;
                //     }
                //     else if (!this.response.success) {
                //         this.error = result.error;
                //         this.posting = false;
                //     }
                // }).catch((error: HttpErrorResponse) => {
                //     this.serverError = error.error;
                //     this.response.success = false;
                //     this.posting = false;
                // });

                // if (this.signatureOptionSelected == 'draw') {
                //     await this.print(this.user_guid)
                // }
                // else if (this.signatureOptionSelected == 'upload') {
                //     await this.blobToImageUpload(this.signatureFile, this.user_guid);
                // }

                //await this.UploadSignature(this.signatureFile,doctor_guid)


                // temporary hack. need to change
            }
            else if (!this.response.success) {
                this.error = result.error;
                this.posting = false;
            }
            this.posting = false;
        }).catch((error: HttpErrorResponse) => {
            this.serverError = error.error;
            this.response.success = false;
            this.posting = false;
        });
        // if (this.resume != null) {
        //     let formResume: FormData = new FormData();
        //     formResume.set("file", this.resume);


        //     await this.doctorsservice.UploadDoctorResume(formResume, this.user_guid).toPromise().then(result => {

        //         this.response = result;
        //         if (this.response.success) {
        //             this.resume_result = result.success;
        //         }
        //         else if (!this.response.success) {
        //             this.error = result.error;
        //             this.posting = false;
        //         }
        //     }).catch((error: HttpErrorResponse) => {
        //         this.serverError = error.error;
        //         this.response.success = false;
        //         this.posting = false;
        //     });
        // }
    }

    async UploadDataAdmin() {

        this.doctorreg.form_data = new Form_Data();
        this.doctorreg.form_data.form_data = this.doctorreg.form_data.create_form_data(this.doctorreg.api_data, new FormData(), "");

        if (this.profilePhoto) {
            this.doctorreg.form_data.form_data.append('avatar', this.profilePhoto);
        }

        if (this.resume) {
            this.doctorreg.form_data.form_data.append('resume', this.resume);
        }

        await this.doctorsservice.createDoctor(this.doctorreg.form_data.form_data).toPromise().then(async result => {

            this.response = result;
            if (this.response.success) {
                this.showForm = false;
                this.display = true;
                await this.showDialog();
                //let user_guid = result.data.user_guid;
                // let formPhoto: FormData = new FormData();
                // formPhoto.set("file", this.profilePhoto);

                // let formResume: FormData = new FormData();
                // formData.set("current_user_guid", this.doctorreg.current_guid);
                // formResume.set("file", this.resume);

                // await this.doctorsservice.UploadDoctorProfilePhoto(formPhoto, user_guid).toPromise().then(result => {

                //     this.response = result;
                //     if (this.response.success) {
                //         this.profile_result = result.success;
                //     }
                //     else if (!this.response.success) {
                //         this.error = result.error;
                //         this.posting = false;
                //     }
                // }).catch((error: HttpErrorResponse) => {
                //     this.serverError = error.error;
                //     this.response.success = false;
                //     this.posting = false;
                // });

                //if (this.profile_result) {
                // this.showForm = false;
                // this.display = true;
                // await this.showDialog();
                //}

            }
            else if (!this.response.success) {
                this.error = result.error;
                this.posting = false;
            }
            this.posting = false;
        }).catch((error: HttpErrorResponse) => {
            this.serverError = error.error;
            this.response.success = false;
            this.posting = false;
        });
    }

    async print(user_guid: string) {

        await this.canvas.nativeElement.toBlob(async (res: Blob) => {

            const file = new File([res], "signature.png", { type: "image/png", lastModified: new Date().valueOf() })
            await this.UploadSignature(file, user_guid);

        });

    }
    async blobToImageUpload(blob, user_guid: string) {
        const file = new File([blob], "signature.png", { type: "image/png", lastModified: new Date().valueOf() })
        await this.UploadSignature(file, user_guid);
    }

    async UploadSignature(file: File, user_guid: string) {
        let form: FormData = new FormData()
        form.set('file', file);
        await this.doctorsservice.UploadSignature(form, user_guid).toPromise().then(async result => {

            this.response = result;
            if (this.response.success) {
                this.sig_result = result.success;
                if (this.profile_result && this.sig_result) {
                    this.posting = false;
                    this.showForm = false;
                    this.display = true;
                    await this.showDialog();
                }
            }
            else if (!this.response.success) {
                this.error = result.error;
                this.posting = false;
            }
        }).catch((error: HttpErrorResponse) => {
            this.serverError = error.error;
            this.response.success = false;
            this.posting = false;
        });
    }

    // temp_submit(){
    //     this.showForm=false;
    //     this.display = true;
    //     this.showDialog();
    // }

    gotodashboard() {
        this.RouterNavigation("/" + this.slug + "/doctor/dashboard");
    }



    changeSignatureOption() {
        if (this.signatureOptionSelected == 'draw') {
            const canvasEl: HTMLCanvasElement = this.canvas.nativeElement;
            this.cx = canvasEl.getContext("2d");
            canvasEl.width = this.width;
            canvasEl.height = this.height;
            this.cx.lineWidth = 3;
            this.cx.lineCap = "round";
            this.cx.strokeStyle = "#000";
            this.captureEvents(canvasEl);
            canvasEl.toBlob((res) => {

            })

        }
        this.imageChangedEvent = "";
        this.croppedImage = "";
        this.canvasRotation = 0;
        this.rotation = 0;
        this.scale = 1;
        this.showCropper = false;
        this.containWithinAspectRatio = false;
        this.transform = {};
        this.signature_file_name = "";
    }

    clearSignatureDraw() {
        const canvasEl: HTMLCanvasElement = this.canvas.nativeElement;
        this.cx = canvasEl.getContext("2d");
        canvasEl.width = this.width;
        canvasEl.height = this.height;
        this.cx.lineWidth = 3;
        this.cx.lineCap = "round";
        this.cx.strokeStyle = "#000";
        this.captureEvents(canvasEl);
        canvasEl.toBlob((res) => {

        });

    }

    saveLocal() {
        this.doctorreg.api_data.timezone = 0;
        if (this.selectedCountry != null) {
            this.doctorreg.api_data.country_id = this.selectedCountry?.id;
        }
        else if (this.selectedCountry == null) {
            this.doctorreg.api_data.country_id = null
        }


        if (this.doctorreg.api_data.date_of_birth_date != null) {
            this.doctorreg.api_data.date_of_birth = this.daterenderService.render_data(this.doctorreg.api_data.date_of_birth_date);
        }
        else if (this.doctorreg.api_data.date_of_birth_date == null || this.doctorreg.api_data.date_of_birth == null) {
            this.doctorreg.api_data.date_of_birth = null;
            this.doctorreg.api_data.date_of_birth_date = null;
        }

        if (this.doctorreg.api_data.years_experience != null) {
            this.doctorreg.api_data.years_experience = Number(this.doctorreg.api_data.years_experience);
        }
        else if (this.doctorreg.api_data.years_experience == null) {
            this.doctorreg.api_data.years_experience = null;
        }


        if (this.selectedState != null) {
            this.doctorreg.api_data.state_name = this.selectedState?.state_name;
        }
        else if (this.selectedState == null) {
            this.doctorreg.api_data.state_name = null
        }
        // 
        if (this.seletedPrimarySpeciality != null) {
            this.doctorreg.api_data.primary_speciality_id = this.seletedPrimarySpeciality?.id;
        }
        else if (this.seletedPrimarySpeciality == null) {
            this.doctorreg.api_data.primary_speciality_id = null;
        }


        if (this.medicalSchool.length == 0 && this.Residency.length == 0 && this.Fellowship.length == 0) {
            this.doctorreg.api_data.education = null
        }
        else if (this.medicalSchool.length > 0 || this.Residency.length > 0 || this.Fellowship.length > 0) {
            this.doctorreg.api_data.education = { medical_school: this.medicalSchool, residency: this.Residency, fellowship: this.Fellowship };
        }

        if (!this.national_license) {
            let tempStatesToPractice: StatesToPractice[] = [];
            // for(let i=0;i<this.StatesToPractice.length;i++)
            // {
            //  this.doctorreg.api_data.states_to_practice.push(this.StatesToPractice[i].name);
            tempStatesToPractice = this.StatesToPractice;
            // }
            this.doctorreg.api_data.states_to_practice = tempStatesToPractice;
        }
        else if (this.national_license) {
            if (this.national_license_no.length > 0) {
                let tempStatesToPractice: StatesToPractice[] = [];
                tempStatesToPractice.push({ si_no: (1).toString(), state_name: "ALL", state_id: 0, license_no: this.national_license_no, state_data: JSON.stringify({ state_name: "ALL", state_id: 0, }) });
                this.doctorreg.api_data.states_to_practice = tempStatesToPractice;
            }
        }

        let tempBoard: string[] = [];
        for (let i = 0; i < this.Board.length; i++) {
            //  this.doctorreg.api_data.board_certification.push(this.Board[i].name)
            tempBoard.push(this.Board[i].name)
        }
        this.doctorreg.api_data.board_certification = tempBoard;

        let tempHonours: string[] = [];
        for (let i = 0; i < this.Honours.length; i++) {
            //  this.doctorreg.api_data.honors_award.spush(this.Honours[i].name)
            tempHonours.push(this.Honours[i].name)
        }
        this.doctorreg.api_data.honors_awards_recognition = tempHonours;

        let tempPublication: string[] = [];
        for (let i = 0; i < this.Publication.length; i++) {
            //  this.doctorreg.publications.push(this.Publication[i].name)
            tempPublication.push(this.Publication[i].name)
        }
        this.doctorreg.api_data.publications = tempPublication

        let tempPrivileges: string[] = [];
        for (let i = 0; i < this.Privileges.length; i++) {
            //  this.doctorreg.hospital_privileges.push(this.Privileges[i].name)
            tempPrivileges.push(this.Privileges[i].name)
        }
        this.doctorreg.api_data.hospital_privileges = tempPrivileges;

        if (this.primary_contact_number?.length > 0) {
            this.doctorreg.api_data.primary_contact_number = '+' + this.selectedPhoneCode_primary + this.primary_contact_number.slice(-10);
        }
        else if (this.primary_contact_number?.length == 0) {
            this.doctorreg.api_data.primary_contact_number = ""
        }
        if (this.secondary_contact_number?.length > 0) {
            this.doctorreg.api_data.secondary_contact_number = '+' + this.selectedPhoneCode_secondary + this.secondary_contact_number.slice(-10);
        }
        else if (this.secondary_contact_number?.length == 0) {
            this.doctorreg.api_data.secondary_contact_number = ""
        }


        if (this.selected_role != null) {
            this.doctorreg.api_data.role_id = this.selected_role?.role_id;
        }
        else if (this.selected_role == null) {
            this.doctorreg.api_data.role_id = null;
        }


        let tempselectedSecondarySpeciality: string[] = [];
        if (this.selectedSecondarySpeciality.length > 0) {
            for (let i = 0; i < this.selectedSecondarySpeciality.length; i++) {
                //  this.doctorreg.secondary_speciality.push(this.selectedSecondarySpeciality[i].specialty_name)
                tempselectedSecondarySpeciality.push(this.selectedSecondarySpeciality[i].toString())
            }
        }

        this.doctorreg.api_data.secondary_speciality = tempselectedSecondarySpeciality;

        let tempselectedLanguageSpoken: string[] = [];
        if (this.selected_language.length > 0) {
            for (let i = 0; i < this.selected_language?.length; i++) {
                tempselectedLanguageSpoken.push(this.selected_language[i].id);
            }
        }

        this.doctorreg.api_data.language_id = tempselectedLanguageSpoken;
        if (this.selectedFeatured != null) {
            if (this.selectedFeatured == "Yes")
                this.doctorreg.api_data.featured_doctor_id = true;
            else if (this.selectedFeatured == "No")
                this.doctorreg.api_data.featured_doctor_id = false;
        }
        else if (this.selectedFeatured == null) {
            this.doctorreg.api_data.featured_doctor_id = null;
        }
        if (this.is_revalidation_cme_false)
            this.doctorreg.api_data.revalidation_cme = null;
        else if (!this.is_revalidation_cme_false)
            this.doctorreg.api_data.revalidation_cme = Number(this.selectedRevalidation_cme.value);




        localStorage.setItem("Registration", JSON.stringify(this.doctorreg));
        this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: "Data has been saved on your browser",
        });


    }

    closeNotesDialouge() {
        this.noteDialog = false;
    }

    private async getLocalProfileData(): Promise<void> {
        this.doctorreg = JSON.parse(localStorage.getItem("Registration"));


        if (this.doctorreg.api_data.country_id != null) {
            for (const country of this.countries) {
                if (country.id.toString() == this.doctorreg.api_data.country_id.toString()) {
                    this.selectedCountry = country;
                    break;
                }
            }
        }
        else if (this.doctorreg.api_data.country_id == null) {
            this.selectedCountry = null;
        }

        if (this.doctorreg.api_data.date_of_birth_date != null) {
            // this.doctorreg.api_data.date_of_birth = this.daterenderService.render_data(this.doctorreg.api_data.date_of_birth_date);
            this.doctorreg.api_data.date_of_birth_date = new Date(this.doctorreg.api_data.date_of_birth.replace(/-/g, '/'));
        }
        else if (this.doctorreg.api_data.date_of_birth_date == null) {
            this.doctorreg.api_data.date_of_birth = null;
        }

        if (this.doctorreg.api_data.years_experience != null) {
            this.doctorreg.api_data.years_experience = Number(this.doctorreg.api_data.years_experience);
        }
        else if (this.doctorreg.api_data.years_experience == null) {
            this.doctorreg.api_data.years_experience = null;
        }
        if (this.doctorreg.api_data.country_id != null) {
            await this.changeStates();

            if (this.doctorreg.api_data.state_name != null) {
                for (const state of this.states) {
                    if (state.state_name.toString() == this.doctorreg.api_data.state_name.toString()) {
                        this.selectedState = state;
                        break;
                    }
                }
            }
            else if (this.doctorreg.api_data.state_name == null) {
                this.selectedState = null;
            }
        }

        if (this.doctorreg.api_data.primary_speciality_id != null) {
            for (const primary_spec of this.specialities) {
                if (primary_spec.id.toString() == this.doctorreg.api_data.primary_speciality_id.toString()) {
                    this.seletedPrimarySpeciality = primary_spec;
                    break;
                }
            }
        }
        else if (this.doctorreg.api_data.primary_speciality_id == null) {
            this.seletedPrimarySpeciality = null
        }

        if (this.doctorreg.api_data.education == null) {
            this.medicalSchool = [];
            this.Residency = [];
            this.Fellowship = [];
            this.doctorreg.api_data.education = { medical_school: this.medicalSchool, residency: this.Residency, fellowship: this.Fellowship };
        }
        else if (this.doctorreg.api_data.education != null) {
            // this.medicalSchool= this.doctorreg.api_data.education?.medical_school;
            // this.Residency= this.doctorreg.api_data.education?.residency;
            // this.Fellowship= this.doctorreg.api_data.education?.fellowship;
            let temp_MedicalSchool: MedicalSchool[] = []
            for (let i = 0; i < this.doctorreg.api_data?.education.medical_school.length; i++) {
                temp_MedicalSchool.push(
                    {
                        si_no: String(i + 1),
                        name: this.doctorreg.api_data?.education.medical_school[i].name.toString(),
                        year: this.doctorreg.api_data?.education.medical_school[i].year.toString(),
                    }
                )
            }
            this.medicalSchool = temp_MedicalSchool;

            let temp_Fellowship: Fellowship[] = [];
            for (let i = 0; i < this.doctorreg.api_data?.education.fellowship.length; i++) {
                temp_Fellowship.push(
                    {
                        si_no: String(i + 1),
                        name: this.doctorreg.api_data?.education.fellowship[i].name.toString(),
                        year: this.doctorreg.api_data?.education.fellowship[i].year.toString(),
                    }
                )
            }
            this.Fellowship = temp_Fellowship;

            let temp_Residency: Residency[] = [];
            for (let i = 0; i < this.doctorreg.api_data?.education.residency.length; i++) {
                temp_Residency.push(
                    {
                        si_no: String(i + 1),
                        name: this.doctorreg.api_data?.education.residency[i].name.toString(),
                        year: this.doctorreg.api_data?.education.residency[i].year.toString(),
                    }
                )
            }
            this.Residency = temp_Residency;
        }
        // this.sec_specialities=this.specialities;
        if (this.selectedCountry != null) {
            this.national_license = this.selectedCountry?.is_national_license;
            if (this.national_license) {
                if (this.doctorreg.api_data.states_to_practice.length > 0) {
                    this.national_license_no = this.doctorreg.api_data.states_to_practice[0].license_no;
                }
            }
            else if (!this.national_license) {
                if (this.doctorreg.api_data.state_name != null) {
                    if (this.doctorreg.api_data.states_to_practice.length > 0) {
                        let temp_StatesToPractice: StatesToPractice[] = []
                        for (let i = 0; i < this.doctorreg.api_data.states_to_practice.length; i++) {
                            temp_StatesToPractice.push(
                                {
                                    si_no: (i + 1).toString(),
                                    state_name: this.doctorreg.api_data.states_to_practice[i].state_name,
                                    state_id: this.doctorreg.api_data.states_to_practice[i].state_id,
                                    license_no: this.doctorreg.api_data.states_to_practice[i].license_no,
                                    state_data: JSON.stringify({
                                        state_name: this.doctorreg.api_data.states_to_practice[i].state_name,
                                        state_id: this.doctorreg.api_data.states_to_practice[i].state_id,
                                    })
                                }
                            )
                        }
                        this.StatesToPractice = temp_StatesToPractice;
                    }
                }
            }
        }
        if (this.selectedCountry == null) {
            this.national_license = false;
            this.national_license_no = "";
            this.StatesToPractice = [];
        }

        let tempSpaecialitiesName: string[] = []
        for (let i = 0; i < this.specialities.length; i++) {
            tempSpaecialitiesName.push(this.specialities[i].specialty_name);
        }
        if (this.doctorreg.api_data?.secondary_speciality.length > 0) {
            for (let i = 0; i < this.doctorreg.api_data?.secondary_speciality?.length; i++) {
                tempSpaecialitiesName.push(this.doctorreg.api_data?.secondary_speciality[i]);
            }

        }

        let tempSpaecialities = Array.from(new Set(tempSpaecialitiesName)).sort()
        let temp: SelectItem[] = [];
        for (let i = 0; i < tempSpaecialities.length; i++) {
            temp.push({ label: tempSpaecialities[i], value: tempSpaecialities[i] });
        }
        this.sec_specialities = temp;
        if (this.doctorreg.api_data?.secondary_speciality.length > 0) {
            this.selectedSecondarySpeciality = this.doctorreg.api_data?.secondary_speciality;
        }

        //     let secondary_speciality_data:any[]=this.doctor.data.doctor_profile.secondary_speciality    
        //     let secondary_speciality_temp=[];
        //     let i=0;            
        // for(const  secondary_spec of secondary_speciality_data){
        //     for(let i=0;i<this.specialities.length;i++){
        //         if(this.specialities[i].id.toString()==secondary_spec.toString()){
        //             secondary_speciality_temp.push(this.specialities[i]);
        //             // break;
        //         }
        //     }
        // }

        // this.selectedSecondarySpeciality=secondary_speciality_temp;


        let language_data: any[] = this.doctorreg.api_data.language_id
        let language_temp = [];
        let j = 0;
        for (const language of language_data) {
            for (let j = 0; j < this.languages.length; j++) {
                if (this.languages[j].id.toString() == language.toString()) {
                    language_temp.push(this.languages[j]);
                    // break;
                }
            }
        }

        this.selected_language = language_temp;


        // this.doctorreg.gender=this.doctorreg.gender;
        // this.doctorreg.first_name=this.doctorreg.first_name;
        // this.doctorreg.middle_name=this.doctorreg.middle_name;
        // this.doctorreg.last_name=this.doctorreg.last_name;

        // this.selectedState=this.doctor.data.state_name;
        // rest
        // this.medicalSchool=this.doctor.data.doctor_profile.education.medical_school;
        // this.doctorreg.years_experience=this.doctor.data.doctor_profile.years_experience;
        //this.doctoreditp.gender = result.data.data.gender;

        let temp_Board: Board[] = [];
        for (let i = 0; i < this.doctorreg.api_data.board_certification.length; i++) {
            temp_Board.push(
                {
                    si_no: String(i + 1),
                    name: this.doctorreg.api_data.board_certification[i]
                }
            )
        }
        this.Board = temp_Board;

        let temp_Publication: Publication[] = [];
        for (let i = 0; i < this.doctorreg.api_data.publications.length; i++) {
            temp_Publication.push(
                {
                    si_no: String(i + 1),
                    name: this.doctorreg.api_data.publications[i]
                }
            )
        }
        this.Publication = temp_Publication;

        let temp_Honours: Honours[] = [];
        for (let i = 0; i < this.doctorreg.api_data.honors_awards_recognition.length; i++) {
            temp_Honours.push(
                {
                    si_no: String(i + 1),
                    name: this.doctorreg.api_data.honors_awards_recognition[i]
                }
            )
        }
        this.Honours = temp_Honours;

        let temp_Privileges: Privileges[] = [];
        for (let i = 0; i < this.doctorreg.api_data.hospital_privileges.length; i++) {
            temp_Privileges.push(
                {
                    si_no: String(i + 1),
                    name: this.doctorreg.api_data.hospital_privileges[i]
                }
            )
        }
        this.Privileges = temp_Privileges;



        // if (this.doctor.data.doctor_profile?.avatar_url == null) {
        //     this.avatar_url = "";
        // }
        // else {
        //     this.avatar_url = this.doctor.data.doctor_profile.avatar_url;
        // }

        // this.label = this.doctorreg.first_name + " " + this.doctorreg.middle_name + " " + this.doctorreg.last_name;


        if (this.selectedCountry != null) {
            if (this.doctorreg.api_data?.primary_contact_number?.length == 0) {
                this.primary_contact_number = "";
            }
            else if (this.doctorreg.api_data?.primary_contact_number?.length > 0) {
                this.primary_contact_number = this.doctorreg.api_data?.primary_contact_number?.slice(-10);
            }
            if (this.doctorreg.api_data?.secondary_contact_number?.length == 0) {
                this.secondary_contact_number = "";
            }
            else if (this.doctorreg.api_data?.secondary_contact_number?.length > 0) {
                this.secondary_contact_number = this.doctorreg.api_data?.secondary_contact_number?.slice(-10);
            }

            // this.doctorreg.description = this.doctor.data.doctor_profile.description;
            // this.Fellowship=this.doctor.data.doctor_profile.education.fellowship;
            // this.Residency=this.doctor.data.doctor_profile.education.residency;
            this.selectedPhoneCode_primary = this.selectedCountry.phone_code;
            this.selectedPhoneCode_secondary = this.selectedCountry.phone_code;
        }
        for (let i = 0; i < this.roles.length; i++) {
            if (this.roles[i].role_id == this.doctorreg.api_data.role_id) {
                this.selected_role = this.roles[i];
            }
        }
        if (this.doctorreg.api_data.revalidation_cme != null) {
            this.is_revalidation_cme_false = false;
            this.selectedRevalidation_cme = { label: this.doctorreg.api_data.revalidation_cme.toString(), value: this.doctorreg.api_data.revalidation_cme.toString() };
        }
        else if (this.doctorreg.api_data.revalidation_cme == null) {
            this.is_revalidation_cme_false = true;
            this.selectedRevalidation_cme = null;
        }

        if (this.doctorreg.api_data.featured_doctor_id != null) {
            if (this.doctorreg.api_data.featured_doctor_id) {
                this.selectedFeatured = "Yes";
            }
            else if (!this.doctorreg.api_data.featured_doctor_id) {
                this.selectedFeatured = "No";
            }
        }
        else if (this.doctorreg.api_data.featured_doctor_id = null) {
            this.selectedFeatured = null;
        }


    }

    async NullChecker() {
        this.masterChecker = false;
        let temp_doctorreg = await JSON.parse(localStorage.getItem("Registration"));
        this.masterChecker = await this.doctorRegistrationCheckerService.RestoreDataNullChecker(temp_doctorreg);
    }

    resetDoctorModel() {
        // this.doctorreg = {
        //     has_saved: null,
        //     current_guid: null,
        //     referral_doctor_guid: null,
        //     recaptcha: "",
        //     salutation: null,
        //     token: null,
        //     d_email: "",
        //     password: "",
        //     confirm_password: "",
        //     first_name: "",
        //     middle_name: "",
        //     last_name: "",
        //     gender: "",
        //     date_of_birth: null,
        //     date_of_birth_date: null,
        //     country_id: null,
        //     is_doctor: null,
        //     state_name: null,
        //     city: "",
        //     address_line_1: "",
        //     address_line_2: "",
        //     zip_code: "",
        //     role_id: null,
        //     primary_speciality_id: null,
        //     secondary_speciality: [],
        //     featured_doctor_id: null,
        //     years_experience: null,
        //     license_number: "",
        //     degree: "",
        //     education: null,
        //     timezone: null,
        //     npi_number: "",
        //     revalidation_cme: null,
        //     states_to_practice: [],
        //     board_certification: [],
        //     honors_awards_recognition: [],
        //     publications: [],
        //     hospital_privileges: [],
        //     description: "",
        //     primary_contact_number: "",
        //     secondary_contact_number: "",
        //     pin: "",
        //     language_id: [],
        // }
        this.doctorreg = this.doctorRegistrationCheckerService.doctorRegistration_init(
            null
        )

        this.medicalSchool = [];
        this.Fellowship = [];
        this.StatesToPractice = [];
        this.Honours = [];
        this.Residency = [];
        this.Privileges = [];
        this.Board = [];
        this.Publication = [];

        this.selectedCountry = null;
        this.selectedState = null;
        this.seletedPrimarySpeciality = null;
        this.national_license = false;
        this.national_license_no = "";
        this.primary_contact_number = "";
        this.secondary_contact_number = "";
        this.selectedPhoneCode_primary = "";
        this.selectedPhoneCode_secondary = "";
        this.selected_role = null
        this.selectedFeatured = null
        this.selectedSecondarySpeciality = [];
        this.selected_language = [];
        this.selectedRevalidation_cme = null;
        this.is_revalidation_cme_false = true;
    }

    async recaptchaReset() {
        this.recaptcha_Reset = false;
        setTimeout(() => {
            this.recaptcha_Reset = true;
        }, 1000)
    }

    resolved(captchaResponse: any) {
        this.doctorreg.api_data.recaptcha = captchaResponse;

    }

    async submitDoctorRegistration() {
        let waitSec = Number((Math.floor(Math.random() * 1000) + 1) % 3);
        this.posting = true;
        await setTimeout(async () => {
            this.submitData();
        }, 5000 + waitSec);
    }

    filteredDocuments(): any[] {
        return this.Document_data.filter(d => d.data.length > 0);
    }

    onFileSelected(event: any, docId: number) {
        const selectedFile = event.files?.[0] ?? null;

        if (selectedFile) {
            this.currentDocId = docId;
            this.uploadForm = {
                file: selectedFile,
                expiryDate: ''
            };
            this.displayUploadDialog = true;
        }
    }

    cancelUpload() {
        this.displayUploadDialog = false;
        this.uploadForm = { file: null, expiryDate: '' };
        this.currentDocId = null;
    }

    confirmUpload() {
        if (!this.uploadForm.file || !this.uploadForm.expiryDate || this.currentDocId === null) {
            this.messageService.add({
                severity: 'warn',
                summary: 'Missing Information',
                detail: 'Please provide both file and expiry date.'
            });
            return;
        }

        const docIndex = this.Document_data.findIndex(d => d.id === this.currentDocId);
        if (docIndex > -1) {
            const formattedDate = this.uploadForm.expiryDate instanceof Date
                ? this.uploadForm.expiryDate.toISOString().split('T')[0]
                : this.uploadForm.expiryDate;

            this.Document_data[docIndex].data = [{
                file: this.uploadForm.file,
                expiryDate: formattedDate
            }];
        }

        this.displayUploadDialog = false;
        this.uploadForm = { file: null, expiryDate: '' };
        this.currentDocId = null;
    }

    async uploadCertificates() {
        for (const doc of this.Document_data) {
            if (doc.data.length > 0) {
                const cert = doc.data[0];
                const formData = new FormData();
                formData.append('name', doc.name);
                formData.append('expiryDate', cert.expiryDate);
                formData.append('file', cert.file);

                try {
                    const result = await this.certificateService
                        .UploadCertificate(formData, this.user_guid)
                        .toPromise();

                    console.log("Successfully uploaded", result);
                } catch (error: any) {
                    this.messageService.add({
                        severity: 'error',
                        detail: error.status == 500
                            ? 'Something went wrong!'
                            : error.error?.message?.toString() || 'Upload failed'
                    });
                }
            }
        }

        this.cdr.detectChanges();
    }

    isCertificateSectionValid(): boolean {
        if (!this.is_uk_country) return true;

        return this.Document_data.every(doc => {
            const cert = doc.data?.[0];
            return cert?.file && cert?.expiryDate;
        });
    }
}
